<template>
  <header class="header">
    <div class="header-container">
      <!-- Logo -->
      <div class="logo" @click="$router.push('/')">
        <img src="@/assets/logo.png" alt="Envisioning Chemistry" />
      </div>
      
      <!-- 桌面端导航 -->
      <nav class="nav desktop-nav">
        <router-link to="/" class="nav-link" :class="{ active: isActive('/') }"
          >重现化学</router-link
        >
        <router-link to="/series" class="nav-link" :class="{ active: isActive('/series') }"
          >系列影片</router-link
        >
        <router-link to="/about" class="nav-link" :class="{ active: isActive('/about') }"
          >关于我们</router-link
        >
        <router-link to="/contact" class="nav-link" :class="{ active: isActive('/contact') }"
          >联系我们</router-link
        >
      </nav>
      
      <!-- 移动端菜单按钮 -->
      <div class="mobile-menu-btn" @click="toggleMenu">
        <div class="menu-icon" :class="{ open: menuOpen }">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
    
    <!-- 移动端导航菜单 -->
    <div class="mobile-nav" :class="{ open: menuOpen }">
      <router-link to="/" class="nav-link" :class="{ active: isActive('/') }" @click="toggleMenu"
        >重现化学</router-link
      >
      <router-link to="/series" class="nav-link" :class="{ active: isActive('/series') }" @click="toggleMenu"
        >系列影片</router-link
      >
      <router-link to="/about" class="nav-link" :class="{ active: isActive('/about') }" @click="toggleMenu"
        >关于我们</router-link
      >
      <router-link to="/contact" class="nav-link" :class="{ active: isActive('/contact') }" @click="toggleMenu"
        >联系我们</router-link
      >
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      menuOpen: false
    };
  },
  methods: {
    // 切换菜单开关
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    
    // 判断当前路由是否激活
    isActive(path) {
      // 处理base路径，确保在/chemistry/路径下也能正确匹配
      const currentPath = this.$route.path;
      return currentPath === path || currentPath === `/chemistry${path}`;
    }
  }
};
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  z-index: 1000;
  padding: 1rem 0;
  transition: all 0.3s ease;
}

.header-container {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.logo {
  position: absolute;
  left: 2rem;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 10;
}

.logo img {
  height: 40px;
  display: block;
}

/* 桌面端导航 */
.desktop-nav {
  display: flex;
  gap: 3rem;
}

.nav-link {
  color: white;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 300;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  position: relative;
  padding: 0.5rem 0;
}

.nav-link:hover {
  color: rgba(255, 255, 255, 0.8);
}

.nav-link.active {
  color: white;
}

.nav-link.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: white;
  transition: width 0.3s ease;
}

/* 移动端菜单按钮 */
.mobile-menu-btn {
  display: none;
  position: absolute;
  right: 2rem;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 100;
}

.menu-icon {
  width: 25px;
  height: 20px;
  position: relative;
}

.menu-icon span {
  display: block;
  position: absolute;
  height: 2px;
  width: 100%;
  background: white;
  border-radius: 2px;
  opacity: 1;
  left: 0;
  transition: all 0.3s ease;
}

.menu-icon span:nth-child(1) {
  top: 0;
}

.menu-icon span:nth-child(2) {
  top: 8px;
}

.menu-icon span:nth-child(3) {
  top: 16px;
}

/* 菜单打开状态 */
.menu-icon.open span:nth-child(1) {
  top: 8px;
  transform: rotate(135deg);
}

.menu-icon.open span:nth-child(2) {
  opacity: 0;
  left: -60px;
}

.menu-icon.open span:nth-child(3) {
  top: 8px;
  transform: rotate(-135deg);
}

/* 移动端导航菜单 */
.mobile-nav {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.9);
  backdrop-filter: blur(10px);
  overflow: hidden;
  transition: all 0.3s ease;
  max-height: 0;
  opacity: 0;
}

.mobile-nav.open {
  max-height: 300px;
  opacity: 1;
  padding: 1rem 0;
}

.mobile-nav .nav-link {
  display: block;
  text-align: center;
  padding: 1rem 0;
  font-size: 1.1rem;
  margin: 0 2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.mobile-nav .nav-link:last-child {
  border-bottom: none;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header {
    padding: 0.8rem 0;
  }
  
  .header-container {
    padding: 0 1rem;
  }
  
  .logo {
    position: static;
    transform: none;
    left: auto;
  }
  
  .logo img {
    height: 35px;
  }
  
  .desktop-nav {
    display: none;
  }
  
  .mobile-menu-btn {
    display: block;
    right: 1rem;
  }
  
  .mobile-nav {
    display: block;
  }
}

/* 平板设备优化 */
@media (min-width: 769px) and (max-width: 1024px) {
  .header-container {
    max-width: 100%;
  }
  
  .desktop-nav {
    gap: 2rem;
  }
  
  .nav-link {
    font-size: 0.95rem;
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .logo img {
    height: 30px;
  }
  
  .menu-icon {
    width: 22px;
    height: 18px;
  }
  
  .menu-icon span {
    height: 2px;
  }
  
  .menu-icon span:nth-child(2) {
    top: 7px;
  }
  
  .menu-icon span:nth-child(3) {
    top: 14px;
  }
}
</style>